export const classes = {
  container: {
    position: 'relative',
  },
  paper: {
    maxWidth: 600,
    minWidth: 320,
  },
};
